import { getGlobalHeadersAsObject } from "../global-headers";

export type Comment = {
	id: number;
	user_email: string;
	user_name: string;
	user_first_name?: string;
	user_id: number;
	comment: string;
	submit_date: string;
};

export const getCommentsByObject = (
	objectName: string,
	objectId: number,
	highlightAssignmentId?: number
): Promise<Comment[]> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getPersonCommentById called with invalid argument id '${objectId}'. Expected number`
		);
	}

	const params = new URLSearchParams();
	if (highlightAssignmentId)
		params.append("highlight", String(highlightAssignmentId));

	return fetch(
		`/api/v2/${objectName}/${objectId}/comments/${params.toString() ? `?${params.toString()}` : ""}`,
		{
			method: "GET",
			headers: getGlobalHeadersAsObject(),
		}
	)
		.then((res) => res.json())
		.catch((err) => console.log(err));
};

export const deleteCommentById = (commentId: number): Promise<Comment> => {
	if (!commentId || typeof commentId !== "number") {
		throw new Error(
			`getPersonCommentById called with invalid argument id '${commentId}'. Expected number`
		);
	}

	return fetch(`/api/v2/comments/${commentId}/`, {
		method: "DELETE",
		headers: getGlobalHeadersAsObject(),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};

export const createComment = (
	objectName: string,
	objectId: number,
	comment: string
): Promise<Comment> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getPersonCommentById called with invalid argument id '${objectId}'. Expected number`
		);
	}

	return fetch(`/api/v2/${objectName}/${objectId}/comments/`, {
		method: "POST",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			object_pk: objectId,
			content_type: "",
			site_id: 1,
			comment: comment,
			name: "test",
			email: "test@odi.com",
		}),
	}).then((res) => res.json());
};

export const updateComment = (
	objectName: string,
	objectId: number,
	commentId: number,
	comment: string
): Promise<Comment> => {
	if (!objectId || typeof objectId !== "number") {
		throw new Error(
			`getPersonCommentById called with invalid argument id '${objectId}'. Expected number`
		);
	}

	return fetch(`/api/v2/${objectName}/${objectId}/comments/${commentId}/`, {
		method: "PUT",
		headers: {
			...getGlobalHeadersAsObject(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			comment: comment,
		}),
	}).then((res) => res.json());
};
